import type { VoidFunctionComponent } from 'react';

import DetailsPanel from '../../../generic/DetailsPanel';
import Markdown from '../../../generic/Markdown';

import DrawerLoading from './Loading';
import DrawerSection from './Section';

type Props = {
  isLoading?: boolean;
  description: string;
};

/**
 * VulnerabilityDrawerDescription simply displays the
 * description of the vuln, or a loading UI if it's loading.
 */
export const VulnerabilityDrawerDescription: VoidFunctionComponent<Props> = ({ isLoading, description }) => (
  <DrawerSection>
    {isLoading ? (
      <DrawerLoading.Description />
    ) : (
      <DetailsPanel
        id="package-inventory-vuln-drawer-description"
        target="Description of vulnerability"
        isLoading={isLoading}
      >
        {description ? (
          <Markdown text={description} />
        ) : (
          <span className="italic">No description found</span>
        )}
      </DetailsPanel>
    )}
  </DrawerSection>
);

export default VulnerabilityDrawerDescription;
